const STORAGE_KEY = 'admin_system_config';

export function setSystemConfig(items: { key: string; value: string | null }[]): void {
  const map: Record<string, string> = {};
  for (const item of items) {
    if (item.value !== null) map[item.key] = item.value;
  }
  localStorage.setItem(STORAGE_KEY, JSON.stringify(map));
}

export function getSystemConfig(key: string): string | undefined {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return undefined;
    const map = JSON.parse(raw) as Record<string, string>;
    return map[key];
  } catch {
    return undefined;
  }
}

/** Patches a single key in the stored system config map after an admin save. */
export function patchSystemConfig(key: string, value: string | null): void {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    const map: Record<string, string> = raw ? (JSON.parse(raw) as Record<string, string>) : {};
    if (value !== null && value !== '') {
      map[key] = value;
    } else {
      delete map[key];
    }
    localStorage.setItem(STORAGE_KEY, JSON.stringify(map));
  } catch {
    // Non-fatal — worst case getSystemConfig returns the old value until next boot
  }
}
